import React from 'react';
import { ServicesSection, InsuranceCTA } from '../components/Sections';
import { heroImages } from '../mock/data';

const Services = () => (
  <div>
    <section className="relative h-[340px] flex items-center bg-black">
      <img src={heroImages.air} alt="Services" className="absolute inset-0 w-full h-full object-cover opacity-50" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="flex items-center gap-3 mb-4"><span className="h-px w-10 bg-[#c8102e]" /><span className="eyebrow text-white">Our Services</span></div>
        <h1 className="text-white font-serif-display text-5xl md:text-6xl font-bold leading-[1.05]">Comprehensive logistics solutions</h1>
      </div>
    </section>
    <ServicesSection />
    <InsuranceCTA />
  </div>
);

export default Services;
